import { render, staticRenderFns } from "./BasketImg.vue?vue&type=template&id=184c7ff0&scoped=true&"
import script from "./BasketImg.vue?vue&type=script&lang=js&"
export * from "./BasketImg.vue?vue&type=script&lang=js&"
import style0 from "./BasketImg.vue?vue&type=style&index=0&id=184c7ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184c7ff0",
  null
  
)

export default component.exports